import React from 'react';
import { isAdminOnlyDoc } from '../../../../../../../../utils/docTags';
import AttachedDocMark from './AttachedDocMark';

/**
 * Searchable picker for attaching an existing library doc to the mission.
 */
const AttachDocPicker = ({
  attachQuery,
  setAttachQuery,
  setAttachPickerOpen,
  libraryLoading,
  attachableDocs,
  onAttach,
}) => (
  <div className="mfv-attached-docs__picker">
    <input
      type="text"
      className="mfv-attached-docs__picker-search"
      placeholder="Search the library…"
      value={attachQuery}
      onChange={(e) => setAttachQuery(e.target.value)}
      autoFocus
      onKeyDown={(e) => {
        if (e.key === 'Escape') {
          e.stopPropagation();
          setAttachPickerOpen(false);
          setAttachQuery('');
        }
      }}
    />
    <div className="mfv-attached-docs__picker-list">
      {libraryLoading ? (
        <div className="mfv-attached-docs__picker-empty">Loading…</div>
      ) : attachableDocs.length === 0 ? (
        <div className="mfv-attached-docs__picker-empty">
          {attachQuery.trim() ? 'No docs match.' : 'Nothing left to attach.'}
        </div>
      ) : (
        attachableDocs.map((doc) => (
          <button
            key={doc.id}
            type="button"
            className="mfv-attached-docs__picker-item"
            onClick={() => onAttach(doc.id)}
          >
            <span className="mfv-attached-docs__row-icon">
              <AttachedDocMark icon={doc.icon} size={16} />
            </span>
            <span className="mfv-attached-docs__row-title">
              {doc.title || 'Untitled Doc'}
            </span>
            {isAdminOnlyDoc(doc) && (
              <span className="mfv-attached-docs__badge">Admin</span>
            )}
          </button>
        ))
      )}
    </div>
  </div>
);

export default AttachDocPicker;
